export const environment = {
  production: false,
  apiUrl: 'https://neuralops.exemplifi.io/api'
  // Add other development-specific configurations here
}; 